import { useMutation } from '@tanstack/react-query';
import { UserTrackingPayload } from '@insurgrid/common';
import { owlClient } from '../../apiUtils/client';

export const insurgridVisitorFunnelTrackingUuidKey =
  'insurgridVisitorFunnelTrackingUuid';
export const insurgridVisitorTrackedKey = 'insurgridVisitorTracked';
export function useTrackUserVisitMutation() {
  const { mutateAsync: trackUserVisit, isLoading: trackingUserVisit } =
    useMutation(
      (data: UserTrackingPayload) =>
        owlClient.tracking.agentLinkVisit({ payload: data }),
      {
        onSuccess: (res, data) => {
          sessionStorage.setItem(insurgridVisitorTrackedKey, '1');
          if (data.trackingUuid) {
            localStorage.setItem(
              insurgridVisitorFunnelTrackingUuidKey,
              data.trackingUuid,
            );
          }
        },
      },
    );
  return { trackingUserVisit, trackUserVisit };
}
